import { Fragment } from "react/jsx-runtime";
import { EnrollmentCertificate } from "../../../Physician/Models/CCEnrollment";
import { Col, Row } from "react-bootstrap";
import CCEnrollmentCertificateAssessment from "./CCEnrollmentCertificateAssessment";
import { AbccAssessment, AbccAssessmentModule, AbccAssessmentStatus } from "../Models/CCAssessment";
import Physician from "../../../Physician/Models/Physician";
import { Certificate } from "../../../Physician/Models/Certificate";
import { getDateWithOffset } from "../../../Shared/Utility/GetDateWithOffset";
import { Link } from "react-router-dom";
import { CCArticleWaiver } from "../../../Physician/Models/CCBlock";

interface IProps{
    physician: Physician;
    ccEnrollmentCertificate: EnrollmentCertificate;
    abccAssessments: AbccAssessment[];
    acceptAbccModuleAttestation: (abccAssessmentModule: AbccAssessmentModule) => void;
    appliedArticleWaivers: Array<CCArticleWaiver>;
}

export default function CCEnrollmentCertficateSummaryCard(props: IProps) {
    const certificate = props.physician.certificates.find((cert: Certificate) => cert.certificateId == props.ccEnrollmentCertificate.certificateId);
    var expirationDate  = getDateWithOffset(certificate.expirationDate);
    // Assume abccAssessments is an array of assessment objects
    const currentYear = new Date().getFullYear();

    const filteredAbccAssessments = props.abccAssessments && props.abccAssessments.filter(abccAssessment => {
        // Check that the assessment has the correct status
        if (abccAssessment.abccAssessmentStatusId !== AbccAssessmentStatus.GradingComplete) {
            return false;
        }
        
        // Convert the API string to a Date using getDateWithOffset
        const assessmentEndDate = getDateWithOffset(abccAssessment.endDate);
        const endYear = assessmentEndDate.getFullYear();

        // Return true if the endDate's year is either this year or last year
        return endYear === currentYear || endYear === currentYear - 1;
    });

    
    return (
        <Fragment>
            <Row className="ccenrollment-certificate-summary">
                <Col>
                    <Row className="ccenrollment-certificate-header">
                        <Col>
                            <div className="mb-0 font-weight-bolder card-title font-size-20"><span>{certificate.certificationName}</span></div>
                        </Col>
                        <Col>
                            <div className="mb-0 font-weight-bolder card-title font-size-20">Assessment Due in Year: <b>{expirationDate.getFullYear()}</b></div>
                        </Col>
                    </Row>
                    {filteredAbccAssessments 
                        && filteredAbccAssessments.filter(a => a.certificateId == certificate.certificateId) 
                        && filteredAbccAssessments.filter(a => a.certificateId == certificate.certificateId).length > 0 && 
                        <Row>
                            <Col md={12} className="text-right">
                                <Link  to="/ExaminationHistory">ABCC Result Available!</Link>
                            </Col>
                            
                        </Row>
                        }
                    <Row>
                        <Col>
                            <CCEnrollmentCertificateAssessment ccEnrollmentCertificate={props.ccEnrollmentCertificate} abccAssessments={props.abccAssessments} acceptAbccModuleAttestation={props.acceptAbccModuleAttestation} appliedArticleWaivers={props.appliedArticleWaivers} expirationYear={expirationDate.getFullYear()} />
                        </Col>
                    </Row>
                    
                    </Col>
                </Row>
        </Fragment>
    );

}